// @flow

/**
 * Export `PrivacyPolicy` template.
 */

export { default } from 'components/legal';
